<template>
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 2.25c-5.376 0-9.75 4.374-9.75 9.75s4.374 9.75 9.75 9.75 9.75-4.374 9.75-9.75S17.376 2.25 12 2.25zm.094 4.5a3.375 3.375 0 110 6.75 3.375 3.375 0 010-6.75zM12 20.25a8.23 8.23 0 01-6.055-2.653C6.359 15.45 10.08 15 12 15c1.92 0 5.64.45 6.055 2.596A8.228 8.228 0 0112 20.25z" fill="#262626"/></svg>
</template>

<script>
export default {
  name: 'userIcon',
};
</script>
